var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMenuHamburger = function SvgMenuHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17v2c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1h22c.6 0 1 .4 1 1zm0-16v2c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h22c.6 0 1 .4 1 1zm0 8v2c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h22c.6 0 1 .4 1 1z",
    fillRule: "evenodd"
  })));
};

export default __webpack_public_path__ + "static/media/menu-hamburger.a9bfb3d5.svg";
export { SvgMenuHamburger as ReactComponent };